'use client';

import { useParams } from 'next/navigation';
import HomeworkSharePage from '@/components/HomeworkSharePage';

export default function SharedHomeworkPage() {
  const params = useParams();
  const shortCode = params.shortCode as string;

  return <HomeworkSharePage shortCode={shortCode} />;
}
